import { render, staticRenderFns } from "./PropertyItem.vue?vue&type=template&id=2a43c532"
import script from "./PropertyItem.vue?vue&type=script&lang=js"
export * from "./PropertyItem.vue?vue&type=script&lang=js"
import style0 from "./PropertyItem.vue?vue&type=style&index=0&id=2a43c532&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports